module.exports = __webpack_public_path__ + "img/logo-halic-tto.8ade020b.jpg";